import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home_thumbnail.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-4bcc33a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home_view" }
const _hoisted_2 = { class: "thumbnail_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thumbnail_mask" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "home_thumbnail"
}, null, -1))
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = { class: "title tracking-in-expand" }
const _hoisted_7 = { class: "sub_title" }
const _hoisted_8 = { class: "sub_title" }
const _hoisted_9 = { class: "indictor" }
const _hoisted_10 = { class: "main" }

import StatisticsView from "./StatisticsView.vue";
import ExporeMore from "./ExporeMore.vue";
import PastProjects from "./PastProjects.vue";
import { onActivated, } from "vue";




export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

onActivated(() => {
  window.scrollTo({ top: 0 });
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("home.HOME_TITLE")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("home.HOME_SUB_TITLE")), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("home.HOME_SUB_TITLE_DOWN")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_icon, {
          name: "arrow-down",
          color: "#fff",
          size: "3rem",
          class: "arrow"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(StatisticsView),
      _createVNode(ExporeMore),
      _createVNode(PastProjects)
    ])
  ]))
}
}

})